/* eslint-disable */
// biome-ignore-all lint: auto-generated
//
// This file is auto-generated by autoexport.
// Do not modify manually, please do: vp run check.
//
// plugin: I18nFixture
// source: i18n/**/*.json
// source: urls/*.json
// source: i18n/*/*.json

import type { LibraryType } from "@pdfking/i18n"
import type { EnumUnion } from "@pdfking/structs"
import { LibraryFromJson } from "@pdfking/i18n"

const raw: LibraryType<Readonly<{
  actions: EnumUnion<{
    ABORT: undefined
    ADD: undefined
    ALL: undefined
    ARE_YOU_SURE: undefined
    CHANGE: undefined
    CLOSE: undefined
    CONTINUE: undefined
    CONTINUE_SHOPPING: undefined
    COPY: undefined
    CREATE_URL: undefined
    DELETE: undefined
    DOWNLOAD: undefined
    DROP_FILE: undefined
    DROP_FILES: undefined
    DROP_OR_CLICK: undefined
    FILE_APPROVAL: undefined
    GO_TO_CART: undefined
    GUEST: undefined
    HIDE: undefined
    LOADING: undefined
    LOGIN: { user: unknown }
    NO_RESULTS: undefined
    OPEN: undefined
    ORDER_ADDED: undefined
    ORDER_REMOVED: undefined
    PRODUCT_ADDED: undefined
    SAVE: undefined
    SEARCH: undefined
    SEND: undefined
    SEND_EMAIL_TO_CLIENT: undefined
    SERVER_ERROR_LONG: undefined
    SHOW_ALL: undefined
  }>
  backend: EnumUnion<{
    ANIMATION_3D: undefined
    ACCEPTED_POLICIES: undefined
    ACCEPTED_POLICY: undefined
    ACCOUNT: undefined
    ACTIONS: undefined
    ADDED: undefined
    ADDITIONAL_INFORMATION: undefined
    ADDRESS: undefined
    ADDRESSES: undefined
    ADDRESS_NAME: undefined
    ADD_TO_CART: undefined
    ADD_X: undefined
    ADVANCED: undefined
    ADVANCE_PAYMENT: undefined
    AGENT: undefined
    ALIAS: undefined
    ALSO_INTERESTED: undefined
    AMOUNT: undefined
    APPLIED_OPTION: undefined
    APPLIED_OPTIONS: undefined
    APPROVAL: undefined
    ARRIVAL_DATE: undefined
    ASPECT_RATIO: undefined
    ATTACH: undefined
    ATTACHMENT: undefined
    ATTACHMENTS: undefined
    ATTACH_FILE: undefined
    ATTACH_FILES_UP_TO_15_MB: undefined
    AVG_PAYMENT_DAYS: undefined
    AXIS_VALUES_SAME: undefined
    A_TANTUAM: undefined
    BACK: undefined
    BAG: undefined
    BANCOMAT: undefined
    BANK_DETAILS: undefined
    BANK_NAME: undefined
    BARCODE: undefined
    BARCODES: undefined
    BASE: undefined
    BIG: undefined
    BILLING: undefined
    BILLING_INFORMATION: undefined
    BILLING_REFERENCE: undefined
    BINDING: undefined
    BLOCK: undefined
    BLOCK_BACKING: undefined
    BOOK: undefined
    BOX_NUMBER: undefined
    BOX_SIZE: undefined
    BROCHURES: undefined
    BULK_MAIL_SENT: undefined
    BUSINESS_NAME: undefined
    BUTTON_BAR: undefined
    CALENDAR: undefined
    CANNOT_ACCESS_TO_YOUR_ACCOUNT: undefined
    CARRIER_DISCLAIMER: undefined
    CART_CHANGED_CONFIRM_AGAIN: undefined
    CART_CHECKOUT_INSTRUCTIONS: undefined
    CART_DISCLAIMER: undefined
    CART_PAYMENT_NOT_COMPLETED: undefined
    CASH: undefined
    CATEGORIES: undefined
    CATEGORY: undefined
    CHANGE_YOUR_DISCOUNT: undefined
    CHANGE_YOUR_IDENTITY: undefined
    CHAR: undefined
    CHECK_EMAIL_LOGIN: undefined
    CHECK_PRINT_FILES: undefined
    CHEQUE: undefined
    CHOOSE_METHOD_TO_PRODUCE: undefined
    CHOOSE_USER: undefined
    CITY: undefined
    COD_HELP: undefined
    COD_NO_NEUTRAL: undefined
    COLLECT_POINT: undefined
    COLLECT_ON_DELIVERY: undefined
    COMMENT: undefined
    COMMENT_AND_ATTACH_FILES: undefined
    COMMERCIAL_USER: undefined
    COMMISSION: undefined
    COMMITIONS: undefined
    COMPANY: undefined
    COMPANY_OR_NAME: undefined
    COMPENSATION: undefined
    COMPLETE_PAYMENT: undefined
    COMPLETED: undefined
    COMPONENT_COST: undefined
    CONFIGURE: undefined
    CONFIGURE_YOUR_PRODUCT: undefined
    CONFIRM: undefined
    CONFIRMED: undefined
    CONFIRM_PAYMENT: undefined
    CONFIRM_THEN_PAY: undefined
    CONGRATULATIONS: undefined
    CONTACT_INFORMATION: undefined
    CONTACT_ME: undefined
    CONTACT_STAFF: undefined
    CONTACT_US: undefined
    CONTACT_US_NOW: undefined
    CONTROL_PANEL: undefined
    COOKIE_CONSENT: undefined
    COPIES: undefined
    CORRECT_ERROR: undefined
    CORRECT_ERRORS: undefined
    COST: undefined
    COST_PROFIT_RATIO: undefined
    COUPON_CART: undefined
    COUPON_EXPIRED: undefined
    COUPON_INCOMPATIBLE: undefined
    COUPON_MAX_VALUE: undefined
    COUPON_MIN_VALUE: undefined
    COUPON_USED: undefined
    CREATED_BY: undefined
    CREATE_USER: undefined
    CREDIT_CARD: undefined
    CREDIT_MEMO: undefined
    CREDIT_REFUND: undefined
    CUSTOMER: undefined
    CUSTOMER_CARE: undefined
    CUSTOMER_INFORMATION: undefined
    CUSTOM_SIZE: undefined
    DATE_OF_ISSUANCE: undefined
    DAY: undefined
    DAYS: undefined
    DAYS_SINCE_LAST_PAYMENT: undefined
    DEBTS_REPORT: undefined
    DEFAULT: undefined
    DEFORM: undefined
    DELAYED_PAYMENT: undefined
    DELETED_SUCCESSFULLY: undefined
    DELIVERY: undefined
    DELIVERY_DATE: undefined
    DELIVERY_DOCUMENT: undefined
    DELIVERY_TIME: undefined
    DEPARTMENT: undefined
    DEPOSIT_PAID_ONLINE: undefined
    DEPTH_UNSUPPORTED: undefined
    DESCRIPTION: undefined
    DIE_CUTTING: undefined
    DIMENSION_SPLIT: undefined
    DIPARTIMENTO: undefined
    DISCOUNT_APPLIED: undefined
    DISCOUNT_TICKET: undefined
    DISCOUNT_UP_TO: undefined
    DOCUMENT: undefined
    DOCUMENTS: undefined
    DOCUMENTS_ATTACHED: undefined
    DOCUMENTS_ISSUED_DATE_RANGE: undefined
    DOCUMENTS_ISSUED_SINGLE_DATE: undefined
    DOCUMENT_DATE: undefined
    DOCUMENT_NUMBER: undefined
    DOCUMENT_PREFIX: undefined
    DOCUMENT_TYPE: undefined
    DOMAIN: undefined
    DONE: undefined
    DON_T_HAVE_AN_ACCOUNT: undefined
    DOUBLE_ENTRIES: undefined
    DOUBLE_ENTRY: undefined
    DOUBLE_ENTRY_RECORD: undefined
    DOUBLE_ENTRY_RECORDS: undefined
    DOWNLOAD_ZIP: undefined
    DO_NOT_REPLACE_DELETE: undefined
    DRAG_AND_DROP_A_FILE_HERE: undefined
    DRAG_AND_DROP_FILES_HERE: undefined
    DRIVER: undefined
    EACH: undefined
    EDIT_SHIPPING_ADDR: undefined
    EMAIL_CONFIRMATION: undefined
    EMAIL_NOT_FOUND: undefined
    EMAIL_SENT: undefined
    EMAIL_TO_SIGNUP: undefined
    EMPTY_CART: undefined
    END_OF_MONTH: undefined
    ENTER_A_NAME_FOR_THIS_PRODUCT: undefined
    ENTER_A_VALID_E_MAIL_ADDRESS: undefined
    ENTER_SDI: undefined
    ENVELOPES: undefined
    EXECUTIVE_OFFICES: undefined
    EXPIRATION_DATE: undefined
    EXPIRED: undefined
    EXPIRED_AMOUNT: undefined
    EXPIRED_REMAINING: undefined
    ORDERS_EXPIRED: undefined
    EXTIMATED_SPINE: undefined
    EXTRA: undefined
    E_WIRE_TRANSFER: undefined
    FAST: undefined
    FATTURATO: undefined
    FEEDBACK: undefined
    FIELD_DUPLICATE: undefined
    FILECHECK: undefined
    FILE_CHECK_COMPLETED: undefined
    FILE_COMMENT_HELP: undefined
    FILE_CORRUPTED: undefined
    FILE_HELP_TUTORIAL: undefined
    FILE_UPLOADED_SUCCESSFULLY: undefined
    FILTERS: undefined
    FINALIZING: undefined
    FINISHED: undefined
    FINISHED_DATE: undefined
    FIRST_NAME: undefined
    FIXED_COST: undefined
    FOLLOWEDS: undefined
    FOLLOWER: undefined
    FOLLOWERS: undefined
    FOOTER: undefined
    FOR: undefined
    FORGOT_PASSWORD_HELP: undefined
    FORMAT: undefined
    FORMATS: undefined
    FOR_EACH_ORDER: undefined
    FOR_EACH_SHIPPING: undefined
    FROM: undefined
    GENERAL_INFORMATION: undefined
    GENERIC: undefined
    GRAPHIC: undefined
    GROUP: undefined
    GROUP_BY: undefined
    GUEST_CHECKOUT: undefined
    HAVE_ACCOUNT_Q: undefined
    HEADER: undefined
    HI: undefined
    HIDDEN: undefined
    HOUR: undefined
    HTML: undefined
    IBAN: undefined
    ICON: undefined
    IGNORE_IF_NOT_ORDERING: undefined
    IMAGE_SELECT: undefined
    IMPROVE_CHECKOUT: undefined
    INCLUDING_COLLECTION_CHARGES: undefined
    INFO: undefined
    INFORMATION_REQUEST: undefined
    INITIAL_COST: undefined
    INSERT_THE_FINAL_PRICE: undefined
    INSTEAD_OF: undefined
    INTANGIBLE: undefined
    INTERIOR: undefined
    INVALID: undefined
    INVALID_LINK: undefined
    INVALID_PRODUCT: undefined
    INVOICE: undefined
    INVOICES: undefined
    INVOICES_DOWNLOAD: undefined
    INVOICE_CANCELED_BY_CREDIT_NOTE: undefined
    INVOICE_REGENERATE: undefined
    IN_THIS_AREA_YOU_CAN_INSERT_COMMENTS_ABOUT_THE_FILES_ATTACHED_IT_IS_NOT_POSSIBLE_TO_ASK_FOR_MODIFICATIONS_TO_THE_ORDER_TO_THE_FILES_SPECIAL_TREATMENTS_OR_FURTHER_SERVICES_FOR_ALL_THIS_PLEASE_CONTACT_OUR_CUSTOMER_CARE: undefined
    IN_X_DAYS: undefined
    ITALIAN_E_BILLING: undefined
    ITALIAN_SOCIAL_SECURITY_CODE: undefined
    IVA: undefined
    I_HAVE_READ_AND_ACCEPTED: undefined
    KIND: undefined
    LABEL: undefined
    LAMINATION: undefined
    LAMINATION_WITH_UV_COATING: undefined
    LANGUAGE: undefined
    LAST_EDIT_DATE: undefined
    LAST_NAME: undefined
    LAYOUT: undefined
    LAYOUTS: undefined
    LAYOUT_DOWNLOAD: undefined
    LEAVE_A_REVIEW_ON: undefined
    LEAVE_YOUR_FEEDBACK: undefined
    LEFT_SIDE: undefined
    LINK: undefined
    LINK_COPY_HINT: undefined
    LINK_EXPIRED: undefined
    LOAN_RECOVERY: undefined
    LOGIN: undefined
    LOGIN_DATA: undefined
    LOGIN_E_MAIL: undefined
    LOGIN_LINK: undefined
    LOGIN_LINK_SENT: undefined
    LOGIN_SUCCESS: { user: unknown }
    LOSS: undefined
    MAIL_SENT_SUCCESS: undefined
    MAINTENANCE_MODE: undefined
    MANAGER: undefined
    MANAGE_PAGES: undefined
    MARGINS: undefined
    MATERIAL: undefined
    MAX_MAIL_USERS_HELP: undefined
    MEAN: undefined
    MERGE: undefined
    MESSAGE: undefined
    METAL_SPIRAL: undefined
    METAL_STAPLE: undefined
    MINIMUM_COST: undefined
    MINIMUM_ORDER: undefined
    MINIMUM_WORKING_DAYS: undefined
    MISSING_PAYMENT: undefined
    MODE: undefined
    MODEL_PK_NOT_EXIST: undefined
    MONTH: undefined
    MOVE: undefined
    MOVED_TO: undefined
    MOVE_SELECTED_OBJECTS: undefined
    MULTIPLE: undefined
    MULTIPLE_SHIPPINGS: undefined
    NAME: undefined
    NAVIGATION: undefined
    NEUTRAL_PACKAGE: undefined
    NEW: undefined
    NEWSLETTER: undefined
    NEWSLETTER_WELCOME: undefined
    NEW_DELIVERY_DATE: undefined
    NEW_FINISHED_DATE: undefined
    NEW_USER: undefined
    NEW_USER_SIGNED_UP: undefined
    NORMAL: undefined
    NOTE: undefined
    NOTIFICATIONS_SENT: undefined
    NOTIFICATION_SETTINGS: undefined
    NOT_INCLUDED: undefined
    NOT_TRACKED: undefined
    NO_ACCESS_PERM: undefined
    NO_EDIT_PERM: undefined
    NO_NOTIFICATION_SENT: undefined
    NO_RESULTS_FOUND: undefined
    NUMBER: undefined
    NUMBERINGS: undefined
    OBJECT_ID: undefined
    OBJECT_TO_REPLACE: undefined
    OF: undefined
    OFFER_CONDITIONS: undefined
    ONLINE_ADVANCE_PAYMENT: undefined
    OPTION: undefined
    OPTIONS: undefined
    OPTIONS_GROUP: undefined
    OPTIONS_GROUPS: undefined
    OPTION_COST: undefined
    OPTION_COSTS: undefined
    ORDERS: undefined
    ORDERS_SHIP_TOGETHER: undefined
    ORDERS_TRACKING: undefined
    ORDER_5PCT_TOLERANCE: undefined
    ORDER_BARCODE: undefined
    ORDER_DATE: undefined
    ORDER_HERE: undefined
    ORDER_IT_AGAIN: undefined
    ORDER_MOVED_PLURAL: undefined
    ORDER_MOVED_SINGULAR: undefined
    ORDER_ON_INVOICE: undefined
    ORDER_PAID_WITH: undefined
    ORDER_PROCESSED: undefined
    ORDER_SUMMARY: undefined
    ORDER_SUMMARY_TEXT: undefined
    ORDER_SUSPENDED: undefined
    ORDER_VALIDATED: undefined
    ORDER_WILL_PAY_WITH: undefined
    ORGANIZE: undefined
    OR_CLICK_TO_BROWSE: undefined
    OTHER: undefined
    OUTFOLDER: undefined
    OUTSOURCING: undefined
    OVERDRAFT: undefined
    OVERDRAFT_SUSPEND: undefined
    OVERDRAFT_WAIT: undefined
    PACKAGE: undefined
    PACKAGES: undefined
    PACKAGING: undefined
    PAGES_TOO_FEW: undefined
    PAGES_TOO_MANY: undefined
    PAID: undefined
    PAID_X_ON_X_FOR_X: undefined
    PALLET: undefined
    PAPER_DELIVERY_NOTE: undefined
    PAPER_DELIVERY_NOTE_HELP: undefined
    PARTNER: undefined
    PASSWORD_AUTO: undefined
    PASSWORD_MISMATCH: undefined
    PASSWORD_REQUIREMENTS: undefined
    PASSWORD_RESET_EMAIL: undefined
    PASSWORD_RESET_SUCCESSFUL: undefined
    PAY: undefined
    PAYMENTS: undefined
    PAYMENTS_VIEW: undefined
    PAYMENT_ACCEPTED: undefined
    PAYMENT_ALREADY_MADE: undefined
    PAYMENT_COUPON_INCOMPATIBLE: undefined
    PAYMENT_DONE: undefined
    PAYMENT_IN_3_INSTALLMENTS: undefined
    PAYMENT_METHOD: undefined
    PAYMENT_OVERDUE: undefined
    PAYMENT_PENDING: undefined
    PAYMENT_REASON_X: undefined
    PAYMENT_REMINDER: undefined
    PAYMENT_STATUS: undefined
    PAYMENT_SUMMARY: undefined
    PAYMENT_WITH_METHOD: undefined
    PAYMENT_WITH_METHOD_FULL: undefined
    PAYPAL: undefined
    PAY_ONLINE: undefined
    PAY_ONLINE_ANYTIME: undefined
    PENDING: undefined
    PENDING_BILLS: undefined
    PEOPLE: undefined
    PERCENTAGE_COST: undefined
    PERMISSION_DENIED: undefined
    PIECES_FOR_BOX: undefined
    PLEASE_LOG_IN_AS: undefined
    PLUS_VAT: undefined
    POLICIES: undefined
    POSTAL_PROMOS: undefined
    POSTAL_PROMOTIONS: undefined
    POSTPONED_PAYMENT: undefined
    PREPAYMENT: undefined
    PREPRESS: undefined
    PRICE: undefined
    PRICELIST: undefined
    PRICES: undefined
    PRINTABLE_SUPPORTS: undefined
    PRINTED: undefined
    PRINT_PDF: undefined
    PRIORITY: undefined
    PRIVILEGE_CARD: undefined
    PROCESSING: undefined
    PROCESSING_ERROR: undefined
    PROCESSING_REQUIRES: undefined
    PROCESSING_SIDES: undefined
    PRODUCT: undefined
    PRODUCTS: undefined
    PRODUCT_CONFIG_ERROR: undefined
    PRODUCT_SALE: undefined
    PRODUCT_SALES: undefined
    PRODUCT_SETTING: undefined
    PRODUCT_SETTINGS: undefined
    PROFIT: undefined
    PROFIT_RATE: undefined
    PROMOS_EXCLUSIVE: undefined
    PROMOTIONS: undefined
    PROMOTIONS_SUBSCRIBE: undefined
    PUBLISH_ON_SITE: undefined
    QUOTATION: undefined
    QUOTATIONS: undefined
    QUOTATION_EXPIRED: undefined
    RADIO_SELECT: undefined
    RATE: undefined
    READY: undefined
    REASON: undefined
    RECEIPT_OF_PAYMENT: undefined
    RECENT_ACTIONS: undefined
    RECIPIENT: undefined
    REDIRECT: undefined
    REDIRECTS: undefined
    REDIRECT_GONE: undefined
    REFERRING_FIRST_QUANTITY: undefined
    REGISTERED_OFFICES: undefined
    REGISTRATION: undefined
    REMAINDER_DUE: undefined
    REMAINING: undefined
    RENDERING_MODE: undefined
    RENEWS_CREDENTIALS: undefined
    REPETITIONS: undefined
    REPORT: undefined
    REPORTS: undefined
    REQUIRED: undefined
    RETURN: undefined
    REVIEW: undefined
    RIGHT_SIDE: undefined
    ROWS: undefined
    SAVE_ADDRESS: undefined
    SECURE_CHECKOUT: undefined
    SECURE_CHECKOUT_TEXT: undefined
    SELECT: undefined
    SELECT_THE_DESIRED_MODEL: undefined
    SELECT_YOUR_USER: undefined
    SELLER: undefined
    SELLER_INFORMATION: undefined
    SELLING: undefined
    SEND_DOCUMENTS_BY_EMAIL: undefined
    SEND_DOCUMENTS_TO_OUTFOLDER: undefined
    SEND_EMAIL: undefined
    SEND_EMAIL_EVERY: undefined
    SEND_INVOICES: undefined
    SEND_NOTIFICATION: undefined
    SEND_RECEIPT_TO_PRODUCE: undefined
    SEND_THANKS: undefined
    SEND_TO_PRINT_OUTFOLDER: undefined
    SEND_WIRE_TO_X: undefined
    SEQUENCE: undefined
    SERVICE: undefined
    SERVICES: undefined
    SETTINGS: undefined
    SHARE: undefined
    SHARE_PRODUCT_TEXT: undefined
    SHIPPED_PRODUCTS: undefined
    SHIPPER: undefined
    SHIPPER_COST: undefined
    SHIPPER_FRIENDLY_NAME: undefined
    SHIPPING: undefined
    SHIPPINGS: undefined
    SHIPPING_ADDRESS: undefined
    SHIPPING_COSTS: undefined
    SHIPPING_DUTIES: undefined
    SHIPPING_NOTES: undefined
    SHIPPING_REASON: undefined
    SHIPPING_TRACKING: undefined
    SHIP_NO_LOGO: undefined
    SHIP_OTHER_ADDRESS: undefined
    SHIP_REGISTERED_OFFICES: undefined
    SHIP_REGISTERED_OFFICES_INCOMPLETE: undefined
    SHIP_WHEN_READY: undefined
    SHOPPING_CART: undefined
    SHOPPING_CART_EMPTY: undefined
    SHORT_DESCRIPTION: undefined
    SHOW: undefined
    SHOW_3D: undefined
    SHOW_ON: undefined
    SHOW_ON_SITE: undefined
    SHOW_PDF: undefined
    SIGNATURE: undefined
    SIGN_IN: undefined
    SIGN_UP: undefined
    SIGN_UP_DONE: undefined
    SIGN_UP_NOW: undefined
    SINGLE_BARCODE: undefined
    SITE: undefined
    SITE_HAS_GIFT: undefined
    SITE_UNDER_MAINTENANCE: undefined
    SIZES: undefined
    SIZE_TOO_LARGE: undefined
    SIZE_TOO_SMALL: undefined
    SPLIT_PAYMENT: undefined
    STAFF_GOODBYE: undefined
    STAFF_MEMBERS: undefined
    STAFF_USER: undefined
    START: undefined
    STARTING_COST: undefined
    STATES: undefined
    STATES_OR_PROVINCES: undefined
    STATE_OR_PROVINCE: undefined
    STATUS: undefined
    STEP: undefined
    STIFF: undefined
    STRAPS: undefined
    STRIPE: undefined
    SUBJECT: undefined
    SUBJECT_COUNT: undefined
    SUBSCRIBE_BENEFITS: undefined
    SUPER_USER: undefined
    SUPPLIER: undefined
    SUPPLIERS: undefined
    SUPPORT_INCOMPATIBLE: undefined
    SUPPORT_LOGIN_HELP: undefined
    SUPPORT_SIZE_INVALID: undefined
    SUPPORT_TOO_THICK: undefined
    SUPPORT_UNSUPPORTED: undefined
    SUSPENDED: undefined
    SWIFT: undefined
    TASK: undefined
    TASKS: undefined
    TAXABLE: undefined
    TEMPLATE_OR_CHECK: undefined
    TEMPLATE_PREVIEW: undefined
    THANKS: undefined
    THANKS_FOR_SIGNING_UP: undefined
    THANKS_FOR_SIGNING_UP_TO: undefined
    THANK_YOU_FOR_CHOOSING: undefined
    THANK_YOU_FOR_CONTACTING_US: undefined
    THICK: undefined
    THIN: undefined
    TO: undefined
    TOOLS: undefined
    TOTAL: undefined
    TOTAL_WITH_VAT: undefined
    TRACKING: undefined
    TRACK_REVIEW: undefined
    TRACK_SHIPPINGS_IN_PROGRESS: undefined
    TRANSACTION: undefined
    TRANSACTIONS: undefined
    TRANSLATE: undefined
    TRASH_ITEM: undefined
    TUBE: undefined
    ULTIMO_ORDINE: undefined
    UNAUTHENTICATED_USER: undefined
    UNITARY_PRICE: undefined
    UNITARY_WEIGHT: undefined
    UNSUBSCRIBE: undefined
    UPDATE: undefined
    UPDATE_BILLING_PROFILE: undefined
    UPDATE_FROM_VIES: undefined
    UPLOADED_FILES: undefined
    UPLOAD_DEADLINE: undefined
    UPLOAD_FILES: undefined
    USED_OVERDRAFT: undefined
    USER: undefined
    USERS: undefined
    USER_DATA_INCOMPLETE: undefined
    USER_DISCOUNT: undefined
    USER_DISCOUNTS: undefined
    USE_FOR_DESIGN: undefined
    UV: undefined
    VALID: undefined
    VALIDATED: undefined
    VALIDATE_SHIPMENT: undefined
    VALIDATING_PAYMENT: undefined
    VALIDATING_PAYMENT_AND_NOTIFY: undefined
    VALUE: undefined
    VALUE_NOT_VALID_CHOICE: undefined
    VARIABLE_COST: undefined
    VARIABLE_WORKING_DAYS: undefined
    VAT: undefined
    VAT_CODE: undefined
    VAT_EU_PREFIX: undefined
    VAT_EXEMPT: undefined
    VAT_INCLUDED: undefined
    VAT_INVALID: undefined
    VAT_NOT_INCLUDED: undefined
    VAT_NOT_VIES: undefined
    VAT_NUMBERS_UPDATED_FROM_VIES: undefined
    VAT_SUSPENDED: undefined
    VIEW_ALL_QUOTES_MADE: undefined
    VIEW_COMPLETED_AND_NEW_ORDERS: undefined
    VISIBLE_OPTIONS: undefined
    VOLUME: undefined
    VOLUMETRIC_INDEX: undefined
    WAREHOUSE: undefined
    WASTE: undefined
    WEBSITE: undefined
    WEEK: undefined
    WEIGHT: undefined
    WEIGHT_FOR_FIRST_QUANTITY: undefined
    WIRE_TRANSFER: undefined
    WITH: undefined
    WITHOUT_DOCUMENT: undefined
    WITH_DOCUMENT: undefined
    WORKING_DAY: undefined
    WORKING_DAYS: undefined
    X_REPORT: undefined
    X_SELECTED_SUCCESSFULLY: undefined
    X_SITEMAP: undefined
    YEAR: undefined
    YOU_HAVE_ORDERS_IN_THE_CART: undefined
    YOU_SAVE: undefined
    ZIPCODE_MISMATCH: undefined
  }>
  cookie: EnumUnion<{ ACCEPT: undefined; DESCRIPTION: undefined; POLICY: undefined; REFUSE: undefined }>
  errors: EnumUnion<{
    BROWSER_ERROR: undefined
    CACHE_EXPIRED: undefined
    FILE_NOT_FOUND: undefined
    FILE_NOT_PDF: undefined
    GENERIC_ERROR: undefined
    INTERNAL_ERROR: undefined
    PERMISSION_ERROR: undefined
  }>
  fidelization: EnumUnion<{
    CARD_ACTIVATED: undefined
    COUPON_NAME: undefined
    DISCOUNT: undefined
    DISCOUNT_COUPON: undefined
    DISCOUNT_COUPONS: undefined
    EMITTED_DISCOUNT_COUPON: undefined
    EMITTED_DISCOUNT_COUPONS: undefined
    EXPIRE_DATE: undefined
    PAYMENT: undefined
    TIMING: undefined
  }>
  filecheck: EnumUnion<{
    BLEED_AREA: undefined
    CHECK_YOUR_FILE: undefined
    CONTAIN: undefined
    CUT_AREA: undefined
    DOWNLOAD_TEMPLATE: undefined
    EXPECTED_FORMAT: undefined
    EXTRA_PAGES: undefined
    FILE: undefined
    FILECHECK: undefined
    FILE_FORMAT: undefined
    FILE_NAME: undefined
    FILL: undefined
    FRONT: undefined
    GUIDES: undefined
    IMPOSITION: undefined
    INFORMATIONS: undefined
    PAGES: undefined
    PLOT_3D: undefined
    PLOT_VIEWER: undefined
    PRINT_FILE: undefined
    REAR: undefined
    RESIZE: undefined
    SCALE: undefined
    SKETCH: undefined
  }>
  frontend: EnumUnion<{
    ADVICE_USERS: undefined
    AFTER: undefined
    ALL_DEVICES: undefined
    COLORS: undefined
    END: undefined
    FILE_BEFORE: undefined
    FORM_CONTACT: undefined
    FRI: undefined
    FROM_MONDAY_TO_FRIDAY: undefined
    GO: undefined
    HOT_PRINTING: undefined
    HOURS: undefined
    INFO_QUOTATION: undefined
    LANGUAGES: undefined
    LOGOS_PROPERTY: undefined
    MON: undefined
    MON_FRI: undefined
    NEED_HELP: undefined
    NEXT: undefined
    NO_SEARCH_RESULTS: undefined
    OPENING_HOURS: undefined
    PAPER_CUTTER: undefined
    PAYMENT_METHODS: undefined
    PERSONAL_PAGE: undefined
    PRESS: undefined
    PREVIOUS: undefined
    PUNCH: undefined
    SAT: undefined
    SIGN_UP_AN_USER: undefined
    SUN: undefined
    THU: undefined
    TRY_ALL_DEVICES: undefined
    WED: undefined
    WELCOME: undefined
    WHITE: undefined
  }>
  imposition: EnumUnion<{
    ACCORDION_FOLD_10_PAGES: undefined
    ACCORDION_FOLD_12_PAGES: undefined
    ALL: undefined
    ALL_FILES: undefined
    BARCODE_AND_SEQUENCES: undefined
    BLEED: undefined
    BOOKS: undefined
    BOOK_MARGIN: undefined
    BOX: undefined
    CALENDAR_BASE: undefined
    CLOSED_FORMAT: undefined
    CLOSED_SIZE: undefined
    CMYK_1_PANTONE: undefined
    CMYK_2_PANTONES: undefined
    CMYK_VARNISH: undefined
    COLORS_PRINT: undefined
    COVER: undefined
    COVERS: undefined
    COVER_MARGIN: undefined
    COVER_RIGHT_FLAP: undefined
    COVER_SPINE: undefined
    COVER_THICKNESS: undefined
    COVER_WITH_ONE_FLAP: undefined
    COVER_WITH_TWO_FLAPS: undefined
    CREATION_DATE: undefined
    CROSSMARKS: undefined
    CROSS_FOLD_8_PAGES: undefined
    CROSS_FOLD_C_FOLD_12_PAGES: undefined
    CUT: undefined
    C_FOLD_6_PAGES: undefined
    DEPTH: undefined
    DIFFERENT_SUBJECTS: undefined
    DIGITAL_PRINT: undefined
    DIGITAL_PRINTS: undefined
    DISTANCES: undefined
    DISTRIBUTE: undefined
    DOUBLE_GATE_FOLD_8_PAGES: undefined
    DOWNLOAD_THE_FILE_FOR: undefined
    DO_NOT_ROTATE: undefined
    ENSURE_MULTIPLE_OF: undefined
    EXTERNAL: undefined
    FILL: undefined
    FINISHED_BOOK_SIZE: undefined
    FOLD: undefined
    FORMAT_BH: undefined
    FRONT_BACK: undefined
    FRONT_REAR: undefined
    GRIPPER_HEAD: undefined
    GROW: undefined
    HALF_FOLD_4_PAGES: undefined
    HEIGHT: undefined
    HELP: undefined
    HIDE_GUIDES: undefined
    HORIZONTAL: undefined
    HOT_FOIL_STAMPING: undefined
    INNER: undefined
    LOOSE_PAGE: undefined
    MACHINE: undefined
    MACHINE_FORMAT: undefined
    MAGAZINE: undefined
    MAGAZINE_WITH_COVER: undefined
    MARGINS: undefined
    MARGINS_HELP: undefined
    MARGINS_MUST_BE_EQUAL: undefined
    MARKINGS: undefined
    MATERIAL: undefined
    MATERIAL_WASTE_WARNING: undefined
    MEASURES: undefined
    MODE: undefined
    MULTI_FORMAT: undefined
    NAMES: undefined
    NOTEPAD_COVER: undefined
    NOTES: undefined
    NO_COVER: undefined
    NO_FILE: undefined
    NO_FOLD: undefined
    NO_PLOT: undefined
    ONE_PANTONE: undefined
    OPENING_ON_HEIGHT: undefined
    ORIENTATION: undefined
    OUTPUT: undefined
    OVAL: undefined
    OVERLAP: undefined
    OVERLAP_ALL: undefined
    PAGE: undefined
    PAGES_MULTIPLE_4: undefined
    PAGES_SPECIFY: undefined
    PANTONE: undefined
    PAPERBACK: undefined
    PAPER_TOO_SMALL: undefined
    PARALLEL_FOLD_8_PAGES: undefined
    PRIMARY: undefined
    PRINT: undefined
    PRINTABLE_AREA: undefined
    PRINT_PROFILES: undefined
    PRINT_RUN: undefined
    PUBLISHING: undefined
    QUANTITY: undefined
    REPETITIONS_HELP: undefined
    RIGID_COVER: undefined
    ROTATE: undefined
    ROUNDED_CORNERS: undefined
    SAME_SHEETS: undefined
    SCALE: undefined
    SCREEN_PRINTING: undefined
    SECURITY: undefined
    SECURITY_MARGIN: undefined
    SECURITY_MARGINS: undefined
    SEMI_RIGID_COVER: undefined
    SEQUENTIAL: undefined
    SHEET: undefined
    SHEETS: undefined
    SHEETS_EXPLANATION: undefined
    SHEET_THICKNESS: undefined
    SIDE_OPENING: undefined
    SIDE_OPENING_NOTE: undefined
    SIGNATURES: undefined
    SINGLE: undefined
    SINGLE_FILE: undefined
    SINGLE_PDF_FILE: undefined
    SIZE: undefined
    SIZE_TOO_LARGE_FOR_MACHINE: undefined
    SPINE: undefined
    SUBJECTS: undefined
    SUBJECTS_HELP: undefined
    SUBJECTS_PRINT: undefined
    SYMMETRIC: undefined
    TEMPLATE: undefined
    THE_FULL_PREVIEW: undefined
    THIS_FIELD_IS_REQUIRED: undefined
    THIS_PREVIEW_IS_PARTIAL: undefined
    THREAD_SEWN: undefined
    TITLE: undefined
    TOP_OPENING: undefined
    TWO_PANTONES: undefined
    VERTICAL: undefined
    WIDTH: undefined
    W_FOLD_8_PAGES: undefined
    Z_FOLD_6_PAGES: undefined
  }>
  publish: EnumUnion<{
    ANSWER: undefined
    ARTICLE: undefined
    ARTICLES: undefined
    AVERAGE: undefined
    CHOOSE_VARIANT: undefined
    DATA_DELETED: undefined
    DATA_UPDATED_SUCCESSFULLY: undefined
    DISALLOWED_FIELDS: undefined
    EDIT_CHILD_PAGES: undefined
    EXCELLENT: undefined
    EXTERNAL: undefined
    GET_INSTANT_PRICING: undefined
    GOTO: undefined
    HIDDEN_FIELDS: undefined
    HOW_TO_MAKE_YOUR_FILE: undefined
    INADEQUATE: undefined
    INSIGHT: undefined
    INSIGHTS: undefined
    LINK_TITLE: undefined
    META_DESCRIPTION: undefined
    META_TAGS: undefined
    META_TITLE: undefined
    MY_EXPERIENCE: undefined
    NICKNAME: undefined
    NICKNAME_PRIVACY: undefined
    ORDERS_PLACED: undefined
    ORGANIC: undefined
    PARENT: undefined
    POOR: undefined
    PRINT_IN_24H: undefined
    PRODUCT_GUIDE: undefined
    PRODUCT_GUIDES: undefined
    PROMOTION: undefined
    PUBLISH: undefined
    RATING: undefined
    REDIRECT: undefined
    REDIRECTS: undefined
    REDIRECT_PATH_HELP: undefined
    RENDER: undefined
    REVIEWS: undefined
    SEARCH_KEYS: undefined
    SELECTED: undefined
    SERVICES_REQUESTED: undefined
    SETUP_DEFAULT_DATA: undefined
    SOURCE: undefined
    SUPPORT: undefined
    TAGS: undefined
    TECHINCAL_SHEET: undefined
    TECHINCAL_SHEETS: undefined
    THANKS_TRUST: undefined
    TRUSTPILOT: undefined
    TYPOGRAPHICAL_GLOSSARY: undefined
    VERY_GOOD: undefined
  }>
  slugs: EnumUnion<{
    SLUG_ACCOUNT: undefined
    SLUG_ADD: undefined
    SLUG_BARCODE: undefined
    SLUG_CART: undefined
    SLUG_CHANGE: undefined
    SLUG_CHANGE_DISCOUNT: undefined
    SLUG_CHANGE_USER: undefined
    SLUG_CONCRETE: undefined
    SLUG_COPY: undefined
    SLUG_DELETE: undefined
    SLUG_DONE: undefined
    SLUG_DOWNLOAD: undefined
    SLUG_EMAIL_SENT: undefined
    SLUG_GLOSSARY: undefined
    SLUG_GO: undefined
    SLUG_HISTORY: undefined
    SLUG_INFORMATION_REQUEST: undefined
    SLUG_LAYOUT: undefined
    SLUG_LOGIN: undefined
    SLUG_LOGOUT: undefined
    SLUG_MAIL: undefined
    SLUG_MATERIALS: undefined
    SLUG_NEWSLETTER: undefined
    SLUG_NOTIFICATION_SETTINGS: undefined
    SLUG_OPTIONS: undefined
    SLUG_PASSWORD_CHANGE: undefined
    SLUG_PASSWORD_RESET: undefined
    SLUG_PAY: undefined
    SLUG_POLICIES: undefined
    SLUG_PROCESSINGS: undefined
    SLUG_PRODUCT: undefined
    SLUG_PROFILE: undefined
    SLUG_QUOTATION: undefined
    SLUG_REGISTRATION: undefined
    SLUG_REPORTS: undefined
    SLUG_REVIEWS: undefined
    SLUG_SHARE: undefined
    SLUG_SIGNUP: undefined
    SLUG_SIZES: undefined
    SLUG_STAFF: undefined
    SLUG_TASKS: undefined
    SLUG_TEMPLATES: undefined
    SLUG_UPDATE: undefined
  }>
  tasks: EnumUnion<{
    CYAN: undefined
    DELETE: undefined
    DOWNLOAD: undefined
    FILE_ONLY: undefined
    MAGLIANA: undefined
    MERGE: undefined
    OPEN: undefined
    SEND: undefined
    SEPARATE: undefined
    SHOW: undefined
    TIBERIO: undefined
  }>
  urls: EnumUnion<{
    admin_barcode: undefined
    upload_s3: undefined
    upload_outfolders: undefined
    autocomplete: { name: unknown }
    notify_frontend_error: undefined
  }>
}>, "en" | "fr" | "it"> = {
  actions: {
    en: () => import("../i18n/actions/en.json"),
    fr: () => import("../i18n/actions/fr.json"),
    it: () => import("../i18n/actions/it.json"),
  },
  backend: {
    en: () => import("../i18n/backend/en.json"),
    fr: () => import("../i18n/backend/fr.json"),
    it: () => import("../i18n/backend/it.json"),
  },
  cookie: {
    en: () => import("../i18n/cookie/en.json"),
    fr: () => import("../i18n/cookie/fr.json"),
    it: () => import("../i18n/cookie/it.json"),
  },
  errors: {
    en: () => import("../i18n/errors/en.json"),
    fr: () => import("../i18n/errors/fr.json"),
    it: () => import("../i18n/errors/it.json"),
  },
  fidelization: {
    en: () => import("../i18n/fidelization/en.json"),
    fr: () => import("../i18n/fidelization/fr.json"),
    it: () => import("../i18n/fidelization/it.json"),
  },
  filecheck: {
    en: () => import("../i18n/filecheck/en.json"),
    fr: () => import("../i18n/filecheck/fr.json"),
    it: () => import("../i18n/filecheck/it.json"),
  },
  frontend: {
    en: () => import("../i18n/frontend/en.json"),
    fr: () => import("../i18n/frontend/fr.json"),
    it: () => import("../i18n/frontend/it.json"),
  },
  imposition: {
    en: () => import("../i18n/imposition/en.json"),
    fr: () => import("../i18n/imposition/fr.json"),
    it: () => import("../i18n/imposition/it.json"),
  },
  publish: {
    en: () => import("../i18n/publish/en.json"),
    fr: () => import("../i18n/publish/fr.json"),
    it: () => import("../i18n/publish/it.json"),
  },
  slugs: {
    en: () => import("../i18n/slugs/en.json"),
    fr: () => import("../i18n/slugs/fr.json"),
    it: () => import("../i18n/slugs/it.json"),
  },
  tasks: {
    en: () => import("../i18n/tasks/en.json"),
    fr: () => import("../i18n/tasks/fr.json"),
    it: () => import("../i18n/tasks/it.json"),
  },
  urls: {
    en: () => import("../urls/en.json"),
    fr: () => import("../urls/fr.json"),
    it: () => import("../urls/it.json"),
  },
} as const

export const {
  actions,
  backend,
  cookie,
  errors,
  fidelization,
  filecheck,
  frontend,
  imposition,
  publish,
  slugs,
  tasks,
  urls,
} = LibraryFromJson(raw)
